// apim-key.interceptor.ts
import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Environment, ENVIRONMENT } from '../auth/auth.tokens';

@Injectable()
export class ApimKeyInterceptor implements HttpInterceptor {

  private env: Environment = inject(ENVIRONMENT);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const key = this.env.internalApi.key;

    // Si no tenim clau configurada, no fem res
    if (!key) {
      return next.handle(req);
    }

    // Només afegim la clau a les crides contra els micros d’APIM
    const toAuth = req.url.startsWith(this.env.baseUrl.auth);
    const toData = req.url.startsWith(this.env.baseUrl.data);

    if (!toAuth && !toData) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': key,
      },
    });

    return next.handle(cloned);
  }
}
